import { useState, useEffect } from "react";
import useFeatureTraits from "./useFeatureTraits";

const useSuggestionBanner = () => {
  const {
    traits: { bannerText, bannerAction },
    isLoading: isLoadingTraits,
  } = useFeatureTraits();
  const [hasSuggestionBanner, setHasSuggestionBanner] = useState(
    Boolean(bannerText) && Boolean(bannerAction)
  );
  const closeSuggestionBanner = () => setHasSuggestionBanner(false);

  useEffect(() => {
    setHasSuggestionBanner(Boolean(bannerText) && Boolean(bannerAction));
  }, [bannerAction, bannerText]);

  return {
    hasSuggestionBanner: hasSuggestionBanner,
    closeSuggestionBanner,
  };
};

export default useSuggestionBanner;
